"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntervalTransporter = void 0;
var transporter_1 = require("./transporter");
var LogStore_1 = require("../LogStore");
// transporter that handles the job with intervals
var IntervalTransporter = /** @class */ (function (_super) {
    __extends(IntervalTransporter, _super);
    function IntervalTransporter(_a) {
        var request = _a.request, interval = _a.interval, batchSize = _a.batchSize;
        var _this = _super.call(this) || this;
        _this.intervalId = 0;
        _this.isPaused = false;
        _this.request = request;
        _this.interval = interval;
        _this.batchSize = batchSize;
        _this.pendingLogs = new LogStore_1.LogStore();
        _this.logStore = new LogStore_1.LogStore();
        _this.onPageHideHandler = function () { return _this.dispose(); };
        _this.onOnlineHandler = function () { return _this.resume(); };
        _this.onOfflineHandler = function () { return _this.pause(); };
        window.addEventListener("pagehide", _this.onPageHideHandler);
        window.addEventListener("online", _this.onOnlineHandler);
        window.addEventListener("offline", _this.onOfflineHandler);
        return _this;
    }
    IntervalTransporter.prototype.log = function (log) {
        var _this = this;
        this.logStore.push(log);
        // if the log store is exceeding the batch size, then we will immediately execute interval job
        // so we emtpy our log store and don't keep more logs than we should
        if (this.logStore.getSize() >= this.batchSize && !this.isPaused) {
            this.intervalJob();
        }
        // if interval job hasn't started yet, then it should start
        if (!this.intervalId) {
            this.intervalId = window.setInterval(function () { return _this.intervalJob(); }, this.interval);
        }
    };
    IntervalTransporter.prototype.intervalJob = function () {
        var batchedLogs = this.logStore.pop(this.batchSize);
        if (batchedLogs.length > 0) {
            this.pendingLogs.pushBatch(batchedLogs);
            this.request(this.pendingLogs.popAllLogs());
        }
    };
    IntervalTransporter.prototype.pause = function () {
        this.isPaused = true;
        if (this.intervalId) {
            window.clearInterval(this.intervalId);
            this.intervalId = 0;
        }
    };
    IntervalTransporter.prototype.resume = function () {
        var _this = this;
        this.isPaused = false;
        // it is possible logs are collected on pause, Hence when it is resumed
        // we need to empty the backlog of logs to easy the job of intervalJob
        if (this.logStore.getSize() > 0) {
            this.pendingLogs.pushBatch(this.logStore.popAllLogs());
        }
        if (this.pendingLogs.getSize() > 0) {
            this.request(this.pendingLogs.popAllLogs());
        }
        if (!this.intervalId) {
            this.intervalId = window.setInterval(function () { return _this.intervalJob(); }, this.interval);
        }
    };
    IntervalTransporter.prototype.dispose = function () {
        // flush all logs in logStore and in pendingLogs
        if (this.logStore.getSize() > 0) {
            this.pendingLogs.pushBatch(this.logStore.popAllLogs());
        }
        if (this.pendingLogs.getSize() > 0) {
            this.request(this.pendingLogs.popAllLogs());
        }
        if (this.intervalId) {
            window.clearInterval(this.intervalId);
        }
        window.removeEventListener("pagehide", this.onPageHideHandler);
        window.removeEventListener("online", this.onOnlineHandler);
        window.removeEventListener("offline", this.onOfflineHandler);
    };
    return IntervalTransporter;
}(transporter_1.Transporter));
exports.IntervalTransporter = IntervalTransporter;
//# sourceMappingURL=intervalTransporter.js.map